export default function Footer() {
  const quickLinks = [
    { label: 'Home', href: '#home' },
    { label: 'About', href: '#about' },
    { label: 'Products', href: '#products' },
    { label: 'Contact', href: '#contact' }
  ];

  const socialLinks = [
    { icon: 'ri-facebook-fill', href: '#', label: 'Facebook' },
    { icon: 'ri-instagram-line', href: '#', label: 'Instagram' },
    { icon: 'ri-linkedin-fill', href: '#', label: 'LinkedIn' },
    { icon: 'ri-youtube-fill', href: '#', label: 'YouTube' }
  ];

  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/57610a2a25a44577dbc5593c17f23216/43d627b8788141608172abab1c6225fc.png"
              alt="Mavani globle"
              className="h-16 w-auto mb-4"
            />
            <p className="text-teal-50 leading-relaxed">
              Professional export business supplying premium rice, spices, and wheat to worldwide markets with quality and reliability.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-teal-50 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Contact Info</h3>
            <div className="space-y-3 text-teal-50">
              <p className="flex items-start">
                <i className="ri-map-pin-line mt-1 mr-2"></i>
                <span className="text-sm">1st Floor Anjana Co op hou Society Heera Bagh, Varachha Road, Near Mangaldip Complex, Surat, Gujarat 385006</span>
              </p>
              <p className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                <a href="mailto:tarangmavani11@gmail.com" className="text-sm hover:text-white cursor-pointer">
                  tarangmavani11@gmail.com
                </a>
              </p>
              <p className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <a href="tel:+919574577631" className="text-sm hover:text-white cursor-pointer">
                  +91 9574577631
                </a>
              </p>
            </div>

            <div className="flex space-x-4 mt-6">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer"
                >
                  <i className={`${social.icon} text-xl`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-teal-500 pt-8 flex flex-col md:flex-row justify-between items-center text-teal-50 text-sm">
          <a
            href="https://iiiem.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors cursor-pointer"
          >
            Copyright &copy; 2026 Mavani Globle All Rights Reserved. Designed &amp; Developed by iiiem
          </a>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="mt-4 md:mt-0 hover:text-white transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
